import React from 'react';
import { Heart } from 'lucide-react';

const ProductCard = ({ product }) => {
  const [isHovered, setIsHovered] = React.useState(false);
  const [isLiked, setIsLiked] = React.useState(false);

  const formatPrice = (price) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
    }).format(price);
  };

  return (
    <div
      className="group relative"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Image Container */}
      <div className="relative aspect-square overflow-hidden bg-gray-50 mb-3">
        <a href="#">
          <img
            src={product.image}
            alt={product.name}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        </a>
        
        {/* Heart Icon */}
        <button
          onClick={() => setIsLiked(!isLiked)}
          className={`absolute top-3 right-3 w-8 h-8 rounded-full flex items-center justify-center transition-all duration-300 ${
            isHovered || isLiked ? 'opacity-100' : 'opacity-0'
          } bg-white/80 hover:bg-white shadow-sm`}
        >
          <Heart
            className={`w-4 h-4 transition-colors ${
              isLiked ? 'fill-red-500 text-red-500' : 'text-gray-600'
            }`}
          />
        </button>

        {/* Quick View Overlay */}
        <div
          className={`absolute inset-0 bg-black/5 flex items-center justify-center transition-opacity duration-300 ${
            isHovered ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <button className="bg-white text-[#1a365d] px-6 py-2 text-sm tracking-wide hover:bg-[#1a365d] hover:text-white transition-colors">
            Quick View
          </button>
        </div>
      </div>

      {/* Product Info */}
      <div className="text-center">
        <a href="#">
          <h3 className="text-sm text-[#1a365d] mb-1 hover:underline transition-all">
            {product.name}
          </h3>
        </a>
        <p className="text-sm text-gray-600">
          <span className="text-gray-400 italic">from </span>
          {formatPrice(product.price)}
        </p>
      </div>
    </div>
  );
};

export default ProductCard;
